var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _vm.isDeviceInCartEnabled
        ? [
            _c("Bouton", {
              ref: "ctaButton",
              class: _vm.additionalClasses,
              attrs: {
                "is-primary": _vm.isPrimary,
                "is-secondary": !_vm.isPrimary,
                "is-inverse": _vm.isInverse,
                "is-wide": _vm.isWide,
                "is-button": !_vm.isLink,
                label: _vm.label,
                "aria-label": _vm.offerNameAccessibility,
                "data-oevent-category": _vm.trackingCategory,
                "data-oevent-action": _vm.formattedTrackingAction,
                "data-oevent-label": _vm.trackingLabel,
              },
              on: { click: _vm.handleCtaClick },
            }),
          ]
        : [
            _c("ob1-boutons", {
              class: _vm.additionalClasses,
              attrs: {
                "data-bs-toggle": "modal",
                "data-bs-target": "#" + _vm.popinId,
                "is-primary": _vm.isPrimary,
                "is-secondary": !_vm.isPrimary,
                "is-inverse": _vm.isInverse,
                "is-wide": _vm.isWide,
                "is-button": !_vm.isLink,
                label: _vm.label,
                "aria-label": _vm.offerNameAccessibility,
                "data-oevent-category": _vm.trackingCategory,
                "data-oevent-action": _vm.formattedTrackingAction,
                "data-oevent-label": _vm.trackingLabel,
              },
            }),
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.fromCds
            ? [
                _c("add-to-cart-popin-cds", {
                  ref: "addToCartPopinCds",
                  attrs: {
                    id: _vm.popinId,
                    "with-device-section": _vm.popinCtasDto.withDeviceSection,
                    "without-device-section":
                      _vm.popinCtasDto.withoutDeviceSection,
                    title: _vm.popinCtasDto.title,
                    advantages: _vm.popinCtasDto.advantages,
                    "selected-offer-info": _vm.popinCtasDto.selectedOfferInfo,
                    visual: _vm.popinCtasDto.visual,
                    "is-sub": _vm.isSub,
                    "offer-name": _vm.popinCtasDto.offerName,
                  },
                }),
              ]
            : [
                _c("with-device-popin", {
                  ref: "withDevicePopin",
                  attrs: {
                    id: _vm.popinId,
                    "with-device-section": _vm.popinCtasDto.withDeviceSection,
                    "without-device-section":
                      _vm.popinCtasDto.withoutDeviceSection,
                    title: _vm.popinCtasDto.title,
                    description: _vm.popinCtasDto.description,
                    visual: _vm.popinCtasDto.visual,
                  },
                }),
              ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }